import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

/**
 * Moves focus onto the element when the screen it heads is mounted.
 *
 * The kiosk swaps whole screens without a page load, so a screen reader would otherwise never be told the
 * screen changed and a keyboard user would be left tabbing from wherever the last button was (convention
 * skill § 8 — "when a screen changes, focus moves to it"). Attach to the screen's `<h1>` with `tabIndex={-1}`
 * so it is programmatically focusable without entering the tab order.
 */
export function useFocusOnMount<T extends HTMLElement>(): RefObject<T | null> {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    ref.current?.focus();
  }, []);

  return ref;
}
